import { ThemeOptions } from '@mui/material';
import variables from '../../../assets/styles/variables.module.scss';
import s from './styles.module.scss';

export const lightTheme: ThemeOptions = {
  palette: {
    mode: 'light',
    background: {
      default: variables.light,
      paper: variables.light,
    },
    error: {
      main: variables.clown_rose,
    },
    secondary: {
      main: variables.clown_rose,
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        classes: {
          root: s['root-input'],
        },
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        classes: {
          root: s['form-helper-text'],
        },
      },
    },
    MuiInput: {
      defaultProps: {
        disableUnderline: true,
        classes: {
          input: s['input-input'],
        },
      },
    },
    MuiMenu: {
      defaultProps: {
        classes: {
          paper: s['menu-paper'],
          list: s['menu-list'],
        },
      },
    },
    MuiMenuItem: {
      defaultProps: {
        classes: {
          root: s['menu-item'],
        },
      },
    },
  },
};
